import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useUpdateCalculationReturnOfInvestments } from '@/pages/CalculatorReturnOfInvestments/hooks';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import type { FormData } from '@/context/CalculatorReturnOfInvestment/types';
import * as S from '../../styles';

const { useFormInstance } = Form;

export function Footer() {
	const form = useFormInstance<FormData>();
	const { id, onPreviousStep, onNextStep } = useCalculateReturnOfInvestments();
	const { isLoading, mutateAsync: updateCalculation } = useUpdateCalculationReturnOfInvestments();

	async function handleOnSubmit(): Promise<void> {
		const { industry, consultancy, internal } = await form.validateFields();
		await updateCalculation({ id: id!, ...industry, ...consultancy, ...internal });
		onNextStep();
	}

	function handleOnPrevious(): void {
		onPreviousStep();
	}

	return (
		<Row justify="center" gutter={[30, 0]}>
			<Col>
				<S.PreviousButton onClick={handleOnPrevious}>{I18n.get('Previous')}</S.PreviousButton>
			</Col>
			<Col>
				<S.NextButton loading={isLoading} onClick={handleOnSubmit}>
					{I18n.get('Next')}
				</S.NextButton>
			</Col>
		</Row>
	);
}
